import { PROBLEMS } from "../../data/content";
import { Eyebrow, Reveal } from "./Primitives";

export const Problems = () => (
  <section data-testid="problem-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
    <Reveal className="max-w-3xl">
      <Eyebrow>The real diagnosis</Eyebrow>
      <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-[-0.03em] text-ink sm:text-5xl">You probably don't have a lead problem. You have a <span className="font-serif font-normal italic text-cobalt-700">revenue-system</span> problem.</h2>
    </Reveal>
    <div className="mt-16 grid gap-6 md:grid-cols-3">
      {PROBLEMS.map((p, i) => (
        <Reveal key={p.title} delay={i * 0.1}>
          <article data-testid={`problem-card-${i}`} className="group">
            <div className="relative aspect-[4/5] overflow-hidden rounded-[28px] [clip-path:inset(0_round_28px)]">
              <img src={p.img} alt={p.title} loading="lazy" className="h-full w-full object-cover grayscale transition duration-[1.2s] ease-out group-hover:scale-105 group-hover:grayscale-0" />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/10 to-transparent" />
              <span className="absolute left-5 top-5 rounded-full bg-paper/90 px-3 py-1 font-mono text-[12px] text-ink">Symptom 0{i + 1}</span>
              <h3 className="absolute bottom-5 left-6 right-6 font-display text-2xl font-bold text-paper sm:text-3xl">{p.title}</h3>
            </div>
            <p className="mt-5 pr-6 text-[15px] leading-relaxed text-ink/70">{p.text}</p>
          </article>
        </Reveal>
      ))}
    </div>
  </section>
);
